import React from 'react'
import Tippy from '@tippyjs/react'
import 'tippy.js/dist/tippy.css'
import { Placement } from 'tippy.js'

interface TooltipProps {
  tooltip: string | JSX.Element
  delay?: number
  placement?: Placement
  children?: React.ReactNode
}

export const Tooltip: React.FC<TooltipProps> = React.memo(({ delay = 350, tooltip, placement = 'bottom', children }) => {
  return (
    <Tippy delay={delay} content={tooltip} allowHTML={true} maxWidth={800} placement={placement} disabled={!tooltip}>
      {children as React.ReactElement<any>}
    </Tippy>
  )
})
